
import { estadoCivil, finalidade } from '@/utils/select-objects'
import gentilicos from '@/constants/gentilico-titulo'
export const orgaosExpedidores = require('@/constants/orgaosExpedidores').default
export const siglasEstados = require('@/constants/siglasEstados').default
export const schemaTitulo = require('@/screens/analise/components/schemaTitulo/' + process.env.ESTADO + '/schema').default
export const schemaExtratoSentenca = require('@/screens/analise/components/schemaExtratoSentenca/schema').default
export const schemaCertidaoArea = require('@/screens/analise/components/schemaCertidaoArea/schema').default
const faixaFronteira = require('@/constants/faixaFronteira').default

function isValidCPF (cpf) {
  if (cpf === undefined || cpf === null) return false

  if ((cpf = cpf.replace(/[^\d]/g, '')).length !== 11) return false

  const cpfInvalidos = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999'
  ]

  if (cpfInvalidos.indexOf(cpf) > -1) return false

  let r,
    i
  let s = 0
  for (i = 1; i <= 9; i++) s += parseInt(cpf[i - 1]) * (11 - i)
  r = (s * 10) % 11
  if (r === 10 || r === 11) r = 0
  if (r !== parseInt(cpf[9])) return false
  s = 0
  for (i = 1; i <= 10; i++) s += parseInt(cpf[i - 1]) * (12 - i)
  r = (s * 10) % 11

  if (r === 10 || r === 11) r = 0

  if (r !== parseInt(cpf[10])) return false

  return true
}

function isValidCNPJ (cnpjFull) {
  if (cnpjFull === null || cnpjFull === undefined) {
    return false
  }
  var cnpj = cnpjFull.toString().replace(/[-_./]/g, '')

  if (cnpj.length !== 14) {
    return false
  }

  let i
  const c = cnpj.substr(0, 12)
  const dv = cnpj.substr(12, 2)
  let d1 = 0

  for (i = 0; i < 12; i++) {
    d1 += c.charAt(11 - i) * (2 + (i % 8))
  }

  if (d1 === 0) {
    return false
  }

  d1 = 11 - (d1 % 11)

  if (d1 > 9) {
    d1 = 0
  }

  if (parseInt(dv.charAt(0)) !== d1) {
    return false
  }

  d1 *= 2

  for (i = 0; i < 12; i++) {
    d1 += c.charAt(11 - i) * (2 + ((i + 1) % 8))
  }

  d1 = 11 - (d1 % 11)

  if (d1 > 9) {
    d1 = 0
  }

  if (parseInt(dv.charAt(1)) !== d1) {
    return false
  }

  return true
}

export function validaCpfCnpj (value) {
  if (value === null || value === '') {
    return ['Campo obrigatório']
  }
  if (isValidCNPJ(value) || isValidCPF(value)) {
    return []
  } else {
    return ['Cpf/cnpj inválido']
  }
}

export const gentilicosTituloNameUpperCase = gentilicos.map((obj) => {
  return {
    ...obj,
    name: obj?.name?.toUpperCase()
  }
})

export const orgaosExpedidoresNameUpperCase = orgaosExpedidores().map((obj) => {
  return {
    ...obj,
    name: obj?.name?.toUpperCase()
  }
})

function validacaoNumeroLivroFolha (value) {
  if (value === '0' || value === '00' || value === '000' || value === null || value === '') {
    return ['Campo obrigatório']
  }
  const valorNumerico = !isNaN(Number(value))
  if (!valorNumerico) {
    return ['Apenas números']
  } else {
    return []
  }
}

export const schemas = {
  emissao_titulo: schemaTitulo(validacaoNumeroLivroFolha, orgaosExpedidores, validaCpfCnpj, siglasEstados, gentilicos, estadoCivil, finalidade, faixaFronteira),
  emissao_extrato_sentenca: schemaExtratoSentenca(),
  emissao_certidao_area: schemaCertidaoArea(validaCpfCnpj, estadoCivil, gentilicos)
}



// WEBPACK FOOTER //
// ./src/screens/analise/components/schemas.js